const PUBLIC_BANK_NAME = 'Public Bank'
const PUBLIC_SHARED_TYPE = 'PUBLIC'

export const resolveSourceBanksForRow = (row) => {
  const names = []
  const collections = row?.collections || []

  collections.forEach((collection) => {
    if (!collection?._id) {
      return
    }

    names.push(collection.name || `${collection._id}`)
  })

  if (row?.sharedType === PUBLIC_SHARED_TYPE) {
    names.push(PUBLIC_BANK_NAME)
  }

  return names
}

export const aggregateCountsByBankName = (rows) => {
  const countsByBankName = {}

  if (!rows?.length) {
    return countsByBankName
  }

  rows.forEach((row) => {
    resolveSourceBanksForRow(row).forEach((bankName) => {
      countsByBankName[bankName] = (countsByBankName[bankName] || 0) + 1
    })
  })

  return countsByBankName
}
